import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TermsConditions = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-[#FAFAFA] text-[#0A0F1C]">
      <Header />
      <div className="pt-28 pb-20">
        <div className="max-w-3xl mx-auto px-6">
          <Link to="/" className="inline-flex items-center text-[#002FA7] hover:text-[#001D66] mb-8 text-xs font-bold uppercase tracking-widest transition-colors">
            <ArrowLeft className="w-4 h-4 mr-1.5" />
            Back to Home
          </Link>

          <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-[#0A0F1C] mb-8">Terms & Conditions</h1>

          <div className="prose prose-slate max-w-none text-[#475569] leading-relaxed">
            <p className="text-base">
              By accessing the <strong className="text-[#0A0F1C]">Trademark Logo Design</strong> website (the "Site"), you acknowledge and accept these terms and conditions. This agreement also incorporates our Privacy Policy. If you do not agree with these terms, please refrain from using the Site.
            </p>

            <div className="bg-[#FF2A00]/10 border border-[#FF2A00]/20 p-4 my-6">
              <p className="text-sm text-[#FF2A00] font-bold">
                IMPORTANT: THIS AGREEMENT INCLUDES A MANDATORY ARBITRATION CLAUSE AND A WAIVER OF CLASS ACTIONS.
              </p>
            </div>

            <h2 className="text-2xl font-bold text-[#0A0F1C] mt-10 mb-4">Conditions for Use</h2>
            <p>By using the Site, you agree that you:</p>
            <ul className="list-disc pl-6 space-y-2 text-sm">
              <li>Will comply with these Terms of Service</li>
              <li>Are 18 years of age or older</li>
              <li>Will not use the Site in any way that violates US laws</li>
              <li>Will not copy or distribute content without our written consent</li>
              <li>Will provide accurate details when registering or submitting content</li>
              <li>Are responsible for all activity under your account</li>
              <li>Will not use the Site for unauthorized commercial purposes</li>
            </ul>

            <h2 className="text-2xl font-bold text-[#0A0F1C] mt-10 mb-4">Your Content</h2>
            <p className="text-sm">
              We reserve the right to publish any content you provide. You agree not to upload content that violates intellectual property rights, infringes on privacy, is unlawful, defamatory, or could harm our company or partners.
            </p>

            <h2 className="text-2xl font-bold text-[#0A0F1C] mt-10 mb-4">Search Services</h2>
            <p className="text-sm">
              We employ reasonable methods to identify potential trademark conflicts. However, we cannot guarantee USPTO approval or that your trademark will not face challenges, even with our search services.
            </p>

            <h2 className="text-2xl font-bold text-[#0A0F1C] mt-10 mb-4">Trademark Search Scope</h2>
            <p className="text-sm">Our <strong>Trademark Logo Design</strong> searches include:</p>
            <ul className="list-disc pl-6 space-y-2 text-sm">
              <li><strong>Federal Search:</strong> Reviews the USPTO database for direct, phonetic, and visual matches</li>
              <li><strong>Federal, State & Common Law:</strong> Extends to all 50 states, business registries, and domain databases</li>
              <li><strong>Global Search:</strong> Includes USPTO, state databases, WIPO, and European Community databases</li>
            </ul>

            <h2 className="text-2xl font-bold text-[#0A0F1C] mt-10 mb-4">Disclaimers & Liability</h2>
            <div className="bg-[#FAFAFA] border border-[#E2E8F0] p-5 text-sm">
              <p className="font-bold text-[#0A0F1C] mb-2">IMPORTANT LEGAL NOTICE</p>
              <p>
                WE PROVIDE THE WEBSITE AND SERVICES "AS IS" AND "AS AVAILABLE." WE DISCLAIM ALL EXPRESS OR IMPLIED WARRANTIES. WE SHALL NOT BE LIABLE FOR INDIRECT, SPECIAL, OR CONSEQUENTIAL DAMAGES ARISING FROM YOUR USE OF THE WEBSITE.
              </p>
            </div>

            <h2 className="text-2xl font-bold text-[#0A0F1C] mt-10 mb-4">Dispute Resolution</h2>
            <p className="text-sm">
              Any dispute shall be resolved by binding individual arbitration conducted by the American Arbitration Association under its Consumer Arbitration Rules.
            </p>
            <div className="bg-[#FF2A00]/10 border border-[#FF2A00]/20 p-4 my-4">
              <p className="text-sm text-[#FF2A00] font-bold">
                NO CLASS ACTION OR REPRESENTATIVE ACTION SHALL BE ALLOWABLE.
              </p>
            </div>

            <h2 className="text-2xl font-bold text-[#0A0F1C] mt-10 mb-4">Refund Policy</h2>
            <p className="text-sm">
              All packages include attorney-conducted searches and are non-refundable. Once a search report is issued, payment is processed within 24-48 hours if no response is received.
            </p>

            <h2 className="text-2xl font-bold text-[#0A0F1C] mt-10 mb-4">Contact Information</h2>
            <div className="bg-[#FAFAFA] border border-[#E2E8F0] p-6 mt-4 text-sm">
              <p><strong>Company:</strong> Trademark Logo Design</p>
              <p><strong>Address:</strong> 9350 Wilshire Blvd Suite 203, Beverly Hills, CA 90212, United States</p>
              <p><strong>Phone:</strong> (800) 555-1234</p>
              <p><strong>Email:</strong> info@trademarklogodesign.com</p>
            </div>

            <p className="text-xs text-slate-400 mt-10 pt-6 border-t border-slate-200">
              <strong>Last Updated:</strong> December 30, 2024
            </p>
            <p className="text-sm mt-4">By using our website, you acknowledge and agree to be bound by these Terms & Conditions.</p>
          </div>
        </div>
      </div>
      <Footer onOpenContactForm={() => {}} />
    </div>
  );
};

export default TermsConditions;
